import ZModal from './ZModal.vue'

export default ZModal
